import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiChannel } from 'core/constants';

import { ModelBase } from 'store/model-base';
import { buildHeaders, XmStore } from 'core/services';

import { StoreAction } from 'store/actions';
import { StepUpAuthLineLock } from './models/step-up-line-lock';
import { StepUpAuthPortOut } from './models/step-up-port-out';
import { StepUpAuthPaymentInstrument } from './models/step-up-payment-instrument';
import { StepUpUpdateContact } from './models/step-up-update-contact';

@Injectable()
export class StepUpAuthApi {
    public static stepUpAuthLineLock(_xmStore: XmStore, http: HttpClient): Observable<StepUpAuthLineLock> {
        return http.get('/step-up/line-lock', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: StepUpAuthLineLock) => StepUpAuthLineLock.create<StepUpAuthLineLock>(response))
        );
    }

    public static stepUpAuthPortOut(_xmStore: XmStore, http: HttpClient): Observable<StepUpAuthPortOut> {
        return http.get('/step-up/port-out', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: StepUpAuthPortOut) => StepUpAuthPortOut.create<StepUpAuthPortOut>(response))
        );
    }

    public static stepUpAuthPaymentInstrument(_xmStore: XmStore, http: HttpClient): Observable<StepUpAuthPaymentInstrument> {
        return http.get('/step-up/add-instrument', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: StepUpAuthPaymentInstrument) => StepUpAuthPaymentInstrument.create<StepUpAuthPaymentInstrument>(response))
        );
    }

    public static stepUpUpdateContact(_xmStore: XmStore, http: HttpClient): Observable<StepUpUpdateContact> {
        return http.get('/step-up/account-manage/edit-contact-point', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: StepUpUpdateContact) => StepUpUpdateContact.create<StepUpUpdateContact>(response))
        );
    }
}

ModelBase.fetchMapping[StoreAction.STEP_UP_LINE_LOCK] = StepUpAuthApi.stepUpAuthLineLock;
ModelBase.fetchMapping[StoreAction.STEP_UP_PORT_OUT] = StepUpAuthApi.stepUpAuthPortOut;
ModelBase.fetchMapping[StoreAction.STEP_UP_ADD_INSTRUMENT] = StepUpAuthApi.stepUpAuthPaymentInstrument;
ModelBase.fetchMapping[StoreAction.STEP_UP_UPDATE_CONTACT] = StepUpAuthApi.stepUpUpdateContact;
